import { cwslapi } from "../index";

// 修改手机号
export const geteditMobile = (data) => { 
  return cwslapi({
    url: "/user/editMobile",
    method: "post",
    data,
  });
};

// 
// 修改密码
export const geteditPwd = (data) => { 
  return cwslapi({
    url: "/user/editPwd",
    method: "post",
    data,
  });
};

// 修改昵称
export const geteditUsernick = (data) => { 
  return cwslapi({
    url: "/user/editUsernick",
    method: "post",
    data,
  });
};